import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Misc } from '../util/misc';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PriceParamService } from 'src/app/services/price-param.service';

@Component({
    selector: 'app-login-component',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    loginForm: UntypedFormGroup;
    returnUrl: string;
    loading: boolean;
    loginMessage: string;

    constructor(
        private fb: UntypedFormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private priceParamService: PriceParamService,
        public misc: Misc
    ) {
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(['/']);
        }
    }

    ngOnInit() {
        this.loginForm = this.fb.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/painel-geral';

        let statusCode = this.route.snapshot.queryParams.statusCode;

        if (statusCode && statusCode > 0) {
            this.loginMessage = this.authenticationService.authenticationUserStatusMessage(Number(statusCode));
        }
    }

    onSubmit() {
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;

        this.authenticationService.login(this.loginForm.value.username, this.loginForm.value.password).subscribe(
            () => {
                this.priceParamService.getByTipo('S').subscribe(
                    result => {
                        localStorage.setItem('parametrosSistemaPW', JSON.stringify(result.items));
                    },
                    error => {
                        this.misc.processError(error, 'Não foi possível carregar a lista de parâmetros do sistema.');
                    }
                );

                this.router.navigate([this.returnUrl]);
            },
            error => {
                this.loading = false;

                this.misc.processError(error);
            }
        );
    }
}
